import { render, staticRenderFns } from "./wolt_work_hour.vue?vue&type=template&id=bd425272&scoped=true&"
import script from "./wolt_work_hour.vue?vue&type=script&lang=js&"
export * from "./wolt_work_hour.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd425272",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bd425272')) {
      api.createRecord('bd425272', component.options)
    } else {
      api.reload('bd425272', component.options)
    }
    module.hot.accept("./wolt_work_hour.vue?vue&type=template&id=bd425272&scoped=true&", function () {
      api.rerender('bd425272', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/aggregators/wolt/location/tabs/wolt_work_hour.vue"
export default component.exports